import { render } from "./UpcomingCoupon.vue?vue&type=template&id=695c5a32"
import script from "./UpcomingCoupon.vue?vue&type=script&lang=js"
export * from "./UpcomingCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__